import { Heading, Text } from 'ui-kit/typography'
import Graph from './pricing-subscription.svg'
import classes from './PricingGraph.module.scss'

export function PricingGraph() {
  return (
    <div className={classes.content}>
      <div className={classes.description}>
        <Heading
          as={'h2'}
          size={'lg'}
          center
          balance
          className={classes.caption}
        >
          Capped Usage-based Fee
        </Heading>
      </div>
      <img
        src={Graph.src}
        width={1068}
        height={470}
        loading='lazy'
        alt='Usage caps start working'
      />
      <Text size={'lg'} center balance className={classes.subtitle}>
        Your usage-based fee grows with the number of Active Customers who use
        integrations provided by us. As usage grows, your price per customer
        becomes lower until there is no more incremental cost.
      </Text>
    </div>
  )
}
